import { render, staticRenderFns } from "./correlation.vue?vue&type=template&id=32b679f6&scoped=true"
import script from "./correlation.vue?vue&type=script&lang=js"
export * from "./correlation.vue?vue&type=script&lang=js"
import style0 from "./correlation.vue?vue&type=style&index=0&id=32b679f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b679f6",
  null
  
)

export default component.exports